<template>
  <div class="content">
    <div class="formularios">
      <v-window v-model="currentView">
        <v-window-item>
          <v-card-actions
            class="d-block"
            style="
              position: sticky;
              top: -20px;
              background-color: white;
              z-index: 1;
            "
          >
            <v-item-group v-model="currentStep" class="text-center" mandatory>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 0"
                  width="12.5%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[0]"
                    :value="tabErrors[0] > 0"
                    inline
                  >
                    1 - Escopo
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 1"
                  width="12.5%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[1]"
                    :value="tabErrors[1] > 0"
                    inline
                  >
                    2 - Classificação
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 2"
                  width="12.5%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[2]"
                    :value="tabErrors[2] > 0"
                    inline
                  >
                    3 - Objetivos
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 3"
                  width="12.5%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[3]"
                    :value="tabErrors[3] > 0"
                    inline
                  >
                    4 - Descrição
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 4"
                  width="12.5%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[4]"
                    :value="tabErrors[4] > 0"
                    inline
                  >
                    5 - Resultados
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 5"
                  width="12.5%"
                >
                  6 - Macro Etapa
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 6"
                  width="12.5%"
                >
                  7 - Atividades
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 7"
                  width="12.5%"
                >
                  8 - Arquivos
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
            </v-item-group>
            <v-progress-linear
              rounded
              color="success"
              :value="((currentStep + 1) / 8) * 100"
            ></v-progress-linear>
          </v-card-actions>
          
        </v-window-item>
      </v-window>
      
      <div :class="`view`" v-if="currentStep == 0">
        <EscopoWindowLB 
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
          :isAgrupamento="isAgrupamento"
        ></EscopoWindowLB>
      </div>
      <div :class="`view`" v-if="currentStep == 1">
        <ClassificacaoWindowLB
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
          :anexoJustificativaTrl.sync="anexoJustificativaTrlLocal"
        ></ClassificacaoWindowLB>
      </div>
      <div :class="`view`" v-if="currentStep == 2">
        <ObjetivosWindowLB
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        >          
        </ObjetivosWindowLB>
      </div>
      <div :class="`view`" v-if="currentStep == 3">
        <DescricaoWindowLB
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        ></DescricaoWindowLB>
      </div>
      <div :class="`view`" v-if="currentStep == 4">      
        <ResultadosWindowLB
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
          :anexoAlinhamentoPoliticas.sync="anexoAlinhamentoPoliticasLocal"
          :anexoDesenvolvimentoEmpresas.sync="anexoDesenvolvimentoEmpresasLocal"
        ></ResultadosWindowLB>  
      </div>
      <div :class="`view`" v-if="currentStep == 5">      
        <MacroEtapaWindowLB
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        >          
        </MacroEtapaWindowLB>
      </div>
      <div :class="`view`" v-if="currentStep == 6">
        <AtividadesWindowLB
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        ></AtividadesWindowLB>
      </div>
      <div :class="`view`" v-if="currentStep == 7">      
        <ArquivosWindowLB
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
          :anexos.sync="anexosLocal"
          :anexoTransmissao.sync="anexoTransmissaoLocal"
          :anexoComprobatorio.sync="anexoComprobatorioLocal"
          :anexoComprobatorioTerceiro.sync="anexoComprobatorioTerceiroLocal"
          :anexoComprobatorioMateriais.sync="anexoComprobatorioMateriaisLocal"
          :anexoCronograma.sync="anexoCronogramaLocal"
          :anexoAnalise="projeto.anexo_analise || []"
        ></ArquivosWindowLB>  
      </div>
    </div>
  </div>
</template>

<script>
import { StatusProjetoEnum } from '@/core/enums/projetos';
import fields from './LBEnquadrados.fields';
import { mapGetters } from 'vuex';
import { AnyAdmin } from '@/core/enums/user-types';

import { isStrictProject, getProjectErrors } from '@/helpers/projectValidators';

export default {

  props: {
    projeto: {
      type: Object,
      required: true
    },
    anexos: {
      type: Array,
      default: () => []
    },
    anexoTransmissao: {
      type: Array,
      default: () => []
    },
    anexoComprobatorio: {
      type: Array,
      default: () => []
    },
    anexoComprobatorioTerceiro: {
      type: Array,
      default: () => []
    },
    anexoComprobatorioMateriais: {
      type: Array,
      default: () => []
    },
    anexoJustificativaTrl: {
      type: Array,
      default: () => []
    },
    anexoAlinhamentoPoliticas: {
      type: Array,
      default: () => []
    },
    anexoDesenvolvimentoEmpresas: {
      type: Array,
      default: () => []
    },
    anexoCronograma: {
      type: Array,
      default: () => []
    },
    isAgrupamento: {
      type: Boolean,
      default: false
    },
    opts: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    EscopoWindowLB: () => import('./components/EscopoWindowLB.vue'),
    ClassificacaoWindowLB: () => import('./components/ClassificacaoWindowLB.vue'),
    ObjetivosWindowLB: () => import('./components/ObjetivosWindowLB.vue'),
    DescricaoWindowLB: () => import('./components/DescricaoWindowLB.vue'),
    ResultadosWindowLB: () => import('./components/ResultadosWindowLB.vue'),
    MacroEtapaWindowLB: () => import('./components/MacroEtapaWindowLB.vue'),
    AtividadesWindowLB: () => import('./components/AtividadesWindowLB.vue'),
    ArquivosWindowLB: () => import('./components/ArquivosWindowLB.vue'),
  },
  data() {
    return {
      currentView: 0,
      currentStep: 0,
      fields,
    }
  },
  computed: {
    ...mapGetters(["clientId", "jwtData", "user"]),
    anexosLocal: {
      get() {
        return this.anexos;
      },
      set(value) {
        this.$emit('update:anexos', value);
      }
    },
    anexoTransmissaoLocal: {
      get() {
        return this.anexoTransmissao;
      },
      set(value) {
        this.$emit('update:anexoTransmissao', value);
      }
    },
    anexoComprobatorioLocal: {
      get() {
        return this.anexoComprobatorio;
      },
      set(value) {
        this.$emit('update:anexoComprobatorio', value);
      }
    },
    anexoComprobatorioTerceiroLocal: {
      get() {
        return this.anexoComprobatorioTerceiro;
      },
      set(value) {
        this.$emit('update:anexoComprobatorioTerceiro', value);
      }
    },
    anexoComprobatorioMateriaisLocal: {
      get() {
        return this.anexoComprobatorioMateriais;
      },
      set(value) {
        this.$emit('update:anexoComprobatorioMateriais', value);
      }
    },
    anexoJustificativaTrlLocal: {
      get() {
        return this.anexoJustificativaTrl;
      },
      set(value) {
        this.$emit('update:anexoJustificativaTrl', value);
      }
    },
    anexoAlinhamentoPoliticasLocal: {
      get() {
        return this.anexoAlinhamentoPoliticas;
      },
      set(value) {
        this.$emit('update:anexoAlinhamentoPoliticas', value);
      }
    },
    anexoDesenvolvimentoEmpresasLocal: {
      get() {
        return this.anexoDesenvolvimentoEmpresas;
      },
      set(value) {
        this.$emit('update:anexoDesenvolvimentoEmpresas', value);
      }
    },
    anexoCronogramaLocal: {
      get() {
        return this.anexoCronograma;
      },
      set(value) {
        this.$emit('update:anexoCronograma', value);
      }
    },
    canEdit: function () {
      const { status } = this.projeto;
      const { tipo_usuario } = this.user;
      // Se 'Em Revisão Galapos' ou 'Em validação final Galapos' somente Galapos pode editar
      // Aprovado para Submissão ou Submetido - ninguém pode editar, mas consultor ainda pode alterar o status
      return (
        ![
          StatusProjetoEnum.APROVADO_SUBMISSAO,
          StatusProjetoEnum.SUBMETIDO,
        ].includes(status) &&
        (![
          StatusProjetoEnum.REVISAO_GALAPOS,
          StatusProjetoEnum.VALIDACAO_FINAL_GALAPOS,
        ].includes(status) ||
          AnyAdmin.includes(tipo_usuario))
      );
    },
    canEditStatus: function () {
      const { status } = this.projeto;
      const { tipo_usuario } = this.user;

      // Aprovado para Submissão ou Submetido - ninguém pode editar, mas consultor ainda pode alterar o status
      return (
        this.canEdit ||
        ([
          StatusProjetoEnum.APROVADO_SUBMISSAO,
          StatusProjetoEnum.SUBMETIDO,
        ].includes(status) &&
          AnyAdmin.includes(tipo_usuario))
      );
    },
    isClient: function () {
      return this.getClient().isClient;
    },
    cliente: function() {
      return this.opts?.clientes.filter((c) => c.id == this.projeto.empresaId)[0] || {
        trabalho: 0
      };
    },

    tabErrors() {
       const isStrict = isStrictProject(this.projeto);
       const escopoFields = this.isAgrupamento
         ? this.fields.escopo.filter(f => f.key !== 'titulo_transmissao')
         : this.fields.escopo;
       return {
         0: getProjectErrors(this.projeto, escopoFields, isStrict),
         1: getProjectErrors(this.projeto, this.fields.classificacao, isStrict),
         2: getProjectErrors(this.projeto, this.fields.objetivos, isStrict),
         3: getProjectErrors(this.projeto, this.fields.descricao, isStrict),
         4: getProjectErrors(this.projeto, this.fields.resultados, isStrict),
       };
    },
  },

  watch: {
    currentStep(val) {
      if (this.projeto && this.projeto.id) {
        localStorage.setItem(`LB_TAB_${this.projeto.id}`, val);
      }
    },
    'projeto.id': {
      handler(val) {
        if (val) {
          this.restoreTab();
          this.$store.dispatch('projetos/fetchProjectComments', {
            empresaId: this.projeto.empresaId,
            projetoId: val
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    restoreTab() {
      if (this.projeto && this.projeto.id) {
        const storedTab = localStorage.getItem(`LB_TAB_${this.projeto.id}`);
        if (storedTab !== null) {
          const step = parseInt(storedTab, 10);
          if (!isNaN(step) && step >= 0 && step <= 7) {
            this.currentStep = step;
          }
        }
      }
    }
  },
  created() {
    this.restoreTab();
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style lang="scss">
</style>